"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppraisalMilestoneKey = exports.IncomeVerificationMilestoneKey = exports.PriorLienReleaseDocumentsMilestoneKey = exports.RemovedCoOwnerMilestoneKey = exports.ExternalBankAccountVerificationMilestoneKey = exports.TrustVerificationMilestoneKey = exports.PostNotarizationReviewMilestoneKey = exports.EmploymentVerificationMilestoneKey = exports.FloodInsuranceMilestoneKey = exports.HazardInsuranceMilestoneKey = exports.LienPositionReviewMilestoneKey = exports.TitleInsuranceMilestoneKey = void 0;
var TitleInsuranceMilestoneKey;
(function (TitleInsuranceMilestoneKey) {
    TitleInsuranceMilestoneKey["titleReport"] = "titleReport";
    TitleInsuranceMilestoneKey["additionalInformation"] = "additionalInformation";
    TitleInsuranceMilestoneKey["manualReview"] = "manualReview";
    TitleInsuranceMilestoneKey["conditionCleared"] = "conditionCleared";
    TitleInsuranceMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(TitleInsuranceMilestoneKey || (exports.TitleInsuranceMilestoneKey = TitleInsuranceMilestoneKey = {}));
/** Lien-position review runs title's timeline without the report step: we do the review ourselves. */
var LienPositionReviewMilestoneKey;
(function (LienPositionReviewMilestoneKey) {
    LienPositionReviewMilestoneKey["lienReview"] = "lienReview";
    LienPositionReviewMilestoneKey["additionalInformation"] = "additionalInformation";
    LienPositionReviewMilestoneKey["manualReview"] = "manualReview";
    LienPositionReviewMilestoneKey["conditionCleared"] = "conditionCleared";
    LienPositionReviewMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(LienPositionReviewMilestoneKey || (exports.LienPositionReviewMilestoneKey = LienPositionReviewMilestoneKey = {}));
var HazardInsuranceMilestoneKey;
(function (HazardInsuranceMilestoneKey) {
    HazardInsuranceMilestoneKey["policy"] = "policy";
    HazardInsuranceMilestoneKey["review"] = "review";
    HazardInsuranceMilestoneKey["conditionCleared"] = "conditionCleared";
    HazardInsuranceMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(HazardInsuranceMilestoneKey || (exports.HazardInsuranceMilestoneKey = HazardInsuranceMilestoneKey = {}));
var FloodInsuranceMilestoneKey;
(function (FloodInsuranceMilestoneKey) {
    FloodInsuranceMilestoneKey["policy"] = "policy";
    FloodInsuranceMilestoneKey["lifeOfLoanPolicy"] = "lifeOfLoanPolicy";
    /** A rejected review precedes the current replacement-policy request; resubmission resumes this step. */
    FloodInsuranceMilestoneKey["manualReview"] = "manualReview";
    FloodInsuranceMilestoneKey["conditionCleared"] = "conditionCleared";
})(FloodInsuranceMilestoneKey || (exports.FloodInsuranceMilestoneKey = FloodInsuranceMilestoneKey = {}));
var EmploymentVerificationMilestoneKey;
(function (EmploymentVerificationMilestoneKey) {
    EmploymentVerificationMilestoneKey["automaticReview"] = "automaticReview";
    EmploymentVerificationMilestoneKey["documentUpload"] = "documentUpload";
    EmploymentVerificationMilestoneKey["manualReview"] = "manualReview";
    EmploymentVerificationMilestoneKey["conditionCleared"] = "conditionCleared";
    EmploymentVerificationMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(EmploymentVerificationMilestoneKey || (exports.EmploymentVerificationMilestoneKey = EmploymentVerificationMilestoneKey = {}));
var PostNotarizationReviewMilestoneKey;
(function (PostNotarizationReviewMilestoneKey) {
    PostNotarizationReviewMilestoneKey["automaticReview"] = "automaticReview";
    PostNotarizationReviewMilestoneKey["documentUpload"] = "documentUpload";
    PostNotarizationReviewMilestoneKey["manualReview"] = "manualReview";
    PostNotarizationReviewMilestoneKey["conditionCleared"] = "conditionCleared";
    PostNotarizationReviewMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(PostNotarizationReviewMilestoneKey || (exports.PostNotarizationReviewMilestoneKey = PostNotarizationReviewMilestoneKey = {}));
var TrustVerificationMilestoneKey;
(function (TrustVerificationMilestoneKey) {
    TrustVerificationMilestoneKey["documentUpload"] = "documentUpload";
    TrustVerificationMilestoneKey["manualReview"] = "manualReview";
    TrustVerificationMilestoneKey["conditionCleared"] = "conditionCleared";
    TrustVerificationMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(TrustVerificationMilestoneKey || (exports.TrustVerificationMilestoneKey = TrustVerificationMilestoneKey = {}));
var ExternalBankAccountVerificationMilestoneKey;
(function (ExternalBankAccountVerificationMilestoneKey) {
    ExternalBankAccountVerificationMilestoneKey["documentUpload"] = "documentUpload";
    ExternalBankAccountVerificationMilestoneKey["manualReview"] = "manualReview";
    ExternalBankAccountVerificationMilestoneKey["conditionCleared"] = "conditionCleared";
    ExternalBankAccountVerificationMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(ExternalBankAccountVerificationMilestoneKey || (exports.ExternalBankAccountVerificationMilestoneKey = ExternalBankAccountVerificationMilestoneKey = {}));
var RemovedCoOwnerMilestoneKey;
(function (RemovedCoOwnerMilestoneKey) {
    RemovedCoOwnerMilestoneKey["documentUpload"] = "documentUpload";
    RemovedCoOwnerMilestoneKey["manualReview"] = "manualReview";
    RemovedCoOwnerMilestoneKey["conditionCleared"] = "conditionCleared";
    RemovedCoOwnerMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(RemovedCoOwnerMilestoneKey || (exports.RemovedCoOwnerMilestoneKey = RemovedCoOwnerMilestoneKey = {}));
// An e-sign borrower authorization waiting on the borrower is its own key so it can say so while current. A wet-signed
// one is uploaded and then reviewed, so it gets a second manual review step.
var PriorLienReleaseDocumentsMilestoneKey;
(function (PriorLienReleaseDocumentsMilestoneKey) {
    PriorLienReleaseDocumentsMilestoneKey["loanNumberConfirmation"] = "loanNumberConfirmation";
    PriorLienReleaseDocumentsMilestoneKey["payoffQuoteUpload"] = "payoffQuoteUpload";
    PriorLienReleaseDocumentsMilestoneKey["manualReview"] = "manualReview";
    PriorLienReleaseDocumentsMilestoneKey["borrowerAuthorization"] = "borrowerAuthorization";
    PriorLienReleaseDocumentsMilestoneKey["borrowerAuthorizationAwaitingESign"] = "borrowerAuthorizationAwaitingESign";
    PriorLienReleaseDocumentsMilestoneKey["borrowerAuthorizationManualReview"] = "borrowerAuthorizationManualReview";
    PriorLienReleaseDocumentsMilestoneKey["conditionCleared"] = "conditionCleared";
})(PriorLienReleaseDocumentsMilestoneKey || (exports.PriorLienReleaseDocumentsMilestoneKey = PriorLienReleaseDocumentsMilestoneKey = {}));
var IncomeVerificationMilestoneKey;
(function (IncomeVerificationMilestoneKey) {
    IncomeVerificationMilestoneKey["automaticReview"] = "automaticReview";
    IncomeVerificationMilestoneKey["manualReview"] = "manualReview";
    IncomeVerificationMilestoneKey["plaidConnection"] = "plaidConnection";
    IncomeVerificationMilestoneKey["conditionCleared"] = "conditionCleared";
    IncomeVerificationMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(IncomeVerificationMilestoneKey || (exports.IncomeVerificationMilestoneKey = IncomeVerificationMilestoneKey = {}));
var AppraisalMilestoneKey;
(function (AppraisalMilestoneKey) {
    AppraisalMilestoneKey["awaitingBorrowerPayment"] = "awaitingBorrowerPayment";
    AppraisalMilestoneKey["appraisalOrdered"] = "appraisalOrdered";
    AppraisalMilestoneKey["appraiserAssigned"] = "appraiserAssigned";
    AppraisalMilestoneKey["propertyInspection"] = "propertyInspection";
    AppraisalMilestoneKey["appraisalReview"] = "appraisalReview";
    AppraisalMilestoneKey["onHold"] = "onHold";
    AppraisalMilestoneKey["orderCancelled"] = "orderCancelled";
    AppraisalMilestoneKey["conditionCleared"] = "conditionCleared";
})(AppraisalMilestoneKey || (exports.AppraisalMilestoneKey = AppraisalMilestoneKey = {}));
